import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/DashboardLayout";

import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import HomePage from "@/pages/HomePage";
import SeoPage from "@/pages/SeoPage";
import AdsPage from "@/pages/AdsPage";
import LeadsPage from "@/pages/LeadsPage";
import ChatPage from "@/pages/ChatPage";
import CalendarPage from "@/pages/CalendarPage";
import MailPage from "@/pages/MailPage";
import LandingsPage from "@/pages/LandingsPage";
import LibraryPage from "@/pages/LibraryPage";
import ItinerariesPage from "@/pages/ItinerariesPage";
import SettingsPage from "@/pages/SettingsPage";
import PublicLandingPage from "@/pages/PublicLandingPage";
import PublicChatPage from "@/pages/PublicChatPage";
import QuestionnairePage from "@/pages/QuestionnairePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Navigate to="/app" replace />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/l/:slug" element={<PublicLandingPage />} />
            <Route path="/chat" element={<PublicChatPage />} />
            <Route path="/questionnaire" element={<QuestionnairePage />} />

            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<HomePage />} />
              <Route path="seo" element={<SeoPage />} />
              <Route path="ads" element={<AdsPage />} />
              <Route path="leads" element={<LeadsPage />} />
              <Route path="chat" element={<ChatPage />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="mail" element={<MailPage />} />
              <Route path="landings" element={<LandingsPage />} />
              <Route path="itineraries" element={<ItinerariesPage />} />
              <Route path="library" element={<LibraryPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/app" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
